// Remove the transition class
let items = document.querySelectorAll('.fade-in');
items.forEach(item => item.classList.remove('animate'));

const observer = new IntersectionObserver(entries => {
	// Loop over the entries
	entries.forEach(entry => {
		// If the element is visible
		if (entry.isIntersecting) {
			// Add the animation class
			entry.target.classList.add('animate');
		}
	});
});
let faders = document.querySelectorAll('.fade-in');
faders.forEach(fader => observer.observe(fader));